import { INTEGRATION_ENDPOINT } from '@/constants';

export const checkIntegrations = async (token: string) => {
    try {
        const response = await fetch(INTEGRATION_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            console.warn('Integration check status:', response.status);
            return;
        }

        const data = await response.json();
        console.log('Integration check result:', data);

    } catch (error) {
        console.error('Integration check error:', error);
    }
};
